import { render, staticRenderFns } from "./MsgPlatSetting.vue?vue&type=template&id=37e07996&scoped=true&"
import script from "./MsgPlatSetting.vue?vue&type=script&lang=js&"
export * from "./MsgPlatSetting.vue?vue&type=script&lang=js&"
import style0 from "./MsgPlatSetting.vue?vue&type=style&index=0&id=37e07996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e07996",
  null
  
)

export default component.exports